import BaseModal from 'components/common/BaseModal';
import {
  obtenerIconoModal,
  obtenerSubTituloModal,
  obtenerTextoBotonCancelar,
  obtenerTextoPrimerBoton,
  obtenerTituloModal,
} from './FuncionesModalFeatureFlags';
import ModalFeatureFlagsStyles from './ModalFeatureFlagsStyles';

const ModalFeatureFlags = ({
  guardarCambios,
  cerrarModal,
  tipo,
}: {
  guardarCambios: () => void;
  cerrarModal: () => void;
  tipo: string;
}) => {
  /**
   * Componente styles
   */
  const styles = ModalFeatureFlagsStyles();

  return (
    <BaseModal
      guardarCambios={guardarCambios}
      cerrarModal={cerrarModal}
      tipo={tipo}
      obtenerIconoModal={obtenerIconoModal}
      obtenerTituloModal={obtenerTituloModal}
      obtenerSubTituloModal={obtenerSubTituloModal}
      obtenerTextoBotonCancelar={obtenerTextoBotonCancelar}
      obtenerTextoPrimerBoton={obtenerTextoPrimerBoton}
      styles={styles}
    />
  );
};

export default ModalFeatureFlags;
